import { useEffect, useRef } from "react";
import { useDimension } from "../contexts/DimensionalContext";
import '../styles/portfolio2d.css';
import '../styles/globals.css';

const Interface2D = () => {
    const { portfolioDimension } = useDimension();
	const portfolio_2d_container = useRef(HTMLDivElement);

	useEffect(() => {
		if(portfolioDimension) {
			portfolio_2d_container.current.style.display = 'none';
		} else {
			portfolio_2d_container.current.style.display = 'block';
		}
	}, [portfolioDimension]);

    return (
        <div ref={portfolio_2d_container} className="portfolio_2d_container">
            
        </div>
    )
}

export default Interface2D